import { createBootstrap } from 'bootstrap-vue-next/plugins/createBootstrap';
import {  BAccordion, BAccordionItem, BAlert, BApp, BAvatar, BAvatarGroup, BBadge, BBreadcrumb, BBreadcrumbItem, BButton,
  BButtonGroup, BButtonToolbar, BCard, BCardBody, BCardFooter, BCardGroup, BCardHeader, BCardImg, BCardSubtitle, BCardText,
  BCardTitle, BCarousel, BCarouselSlide, BCloseButton, BCol, BCollapse, BContainer, BDropdown, BDropdownDivider, BDropdownForm,
  BDropdownGroup, BDropdownHeader, BDropdownItem, BDropdownItemButton, BDropdownText, BForm, BFormCheckbox, BFormCheckboxGroup, BFormDatalist, BFormFile,
  BFormFloatingLabel, BFormGroup, BFormInput, BFormInvalidFeedback, BFormRadio, BFormRadioGroup, BFormRating, BFormRow, BFormSelect, BFormSelectOption,
  BFormSelectOptionGroup, BFormSpinbutton, BFormTag, BFormTags, BFormText, BFormTextarea, BFormValidFeedback, BImg, BInput, BInputGroup,
  BInputGroupText, BLink, BListGroup, BListGroupItem, BModal, BModalOrchestrator, BNav, BNavForm, BNavItem, BNavItemDropdown,
  BNavText, BNavbar, BNavbarBrand, BNavbarNav, BNavbarToggle, BOffcanvas, BOrchestrator, BOverlay, BPagination, BPlaceholder,
  BPlaceholderButton, BPlaceholderCard, BPlaceholderTable, BPlaceholderWrapper, BPopover, BPopoverOrchestrator, BProgress, BProgressBar, BRow, BSpinner,
  BTab, BTable, BTableLite, BTableSimple, BTabs, BTbody, BTd, BTfoot, BTh, BThead,
  BToast, BToastOrchestrator, BTooltip, BTr, BootstrapVueNextResolver, BvCarouselEvent, BvEvent, BvTriggerableEvent, Components, Composables,
  Directives, Plugins, Resolvers, Types, Utils, componentNames, componentsWithExternalPath, composableNames, composablesWithExternalPath,
  directiveNames, directivesWithExternalPath, orchestratorPlugin, registryPlugin, rtlPlugin, useBreadcrumb, useColorMode, useModal,
  useOrchestratorRegistry, usePopover,  useProvideDefaults, useRegistry, useScrollspy, useToast,
  useToggle, vBColorMode, vBModal, vBPopover, vBScrollspy, vBToggle, vBTooltip } from 'bootstrap-vue-next';
// usePopoverController,useModalController, useToastController,
// import { BIcon } from 'bootstrap-vue-next'

// import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';

export default function registerBootstrapControls(app) {
  app.component('BAccordion', BAccordion);
  app.component('BAccordionItem', BAccordionItem);
  app.component('BAlert', BAlert);
  app.component('BApp', BApp);
  app.component('BAvatar', BAvatar);
  app.component('BAvatarGroup', BAvatarGroup);
  app.component('BBadge', BBadge);
  app.component('BBreadcrumb', BBreadcrumb);
  app.component('BBreadcrumbItem', BBreadcrumbItem);
  app.component('BButton', BButton);
  app.component('BBtn', BButton);
  app.component('BButtonGroup', BButtonGroup);
  app.component('BButtonToolbar', BButtonToolbar);
  app.component('BCard', BCard);
  app.component('BCardBody', BCardBody);
  app.component('BCardFooter', BCardFooter);
  app.component('BCardGroup', BCardGroup);
  app.component('BCardHeader', BCardHeader);
  app.component('BCardImg', BCardImg);
  app.component('BCardSubtitle', BCardSubtitle);
  app.component('BCardText', BCardText);
  app.component('BCardTitle', BCardTitle);
  app.component('BCarousel', BCarousel);
  app.component('BCarouselSlide', BCarouselSlide);
  app.component('BCloseButton', BCloseButton);
  app.component('BCol', BCol);
  app.component('BCollapse', BCollapse);
  app.component('BContainer', BContainer);
  app.component('BDropdown', BDropdown);
  app.component('BDropdownDivider', BDropdownDivider);
  app.component('BDropdownForm', BDropdownForm);
  app.component('BDropdownGroup', BDropdownGroup);
  app.component('BDropdownHeader', BDropdownHeader);
  app.component('BDropdownItem', BDropdownItem);
  app.component('BDropdownItemButton', BDropdownItemButton);
  app.component('BDropdownText', BDropdownText);
  app.component('BForm', BForm);
  app.component('BFormCheckbox', BFormCheckbox);
  app.component('BFormCheckboxGroup', BFormCheckboxGroup);
  app.component('BFormDatalist', BFormDatalist);
  app.component('BFormFile', BFormFile);
  app.component('BFormFloatingLabel', BFormFloatingLabel);
  app.component('BFormGroup', BFormGroup);
  app.component('BFormInput', BFormInput);
  app.component('BFormInvalidFeedback', BFormInvalidFeedback);
  app.component('BFormRadio', BFormRadio);
  app.component('BFormRadioGroup', BFormRadioGroup);
  app.component('BFormRating', BFormRating);
  app.component('BFormRow', BFormRow);
  app.component('BFormSelect', BFormSelect);
  app.component('BFormSelectOption', BFormSelectOption);
  app.component('BFormSelectOptionGroup', BFormSelectOptionGroup);
  app.component('BFormSpinbutton', BFormSpinbutton);
  app.component('BFormTag', BFormTag);
  app.component('BFormTags', BFormTags);
  app.component('BFormText', BFormText);
  app.component('BFormTextarea', BFormTextarea);
  app.component('BFormValidFeedback', BFormValidFeedback);
  app.component('BImg', BImg);
  app.component('BInput', BInput);
  app.component('BInputGroup', BInputGroup);
  app.component('BInputGroupText', BInputGroupText);
  app.component('BLink', BLink);
  app.component('BListGroup', BListGroup);
  app.component('BListGroupItem', BListGroupItem);
  app.component('BModal', BModal);
  app.component('BModalOrchestrator', BModalOrchestrator);
  app.component('BNav', BNav);
  app.component('BNavForm', BNavForm);
  app.component('BNavItem', BNavItem);
  app.component('BNavItemDropdown', BNavItemDropdown);
  app.component('BNavText', BNavText);
  app.component('BNavbar', BNavbar);
  app.component('BNavbarBrand', BNavbarBrand);
  app.component('BNavbarNav', BNavbarNav);
  app.component('BNavbarToggle', BNavbarToggle);
  app.component('BOffcanvas', BOffcanvas);
  app.component('BOrchestrator', BOrchestrator);
  app.component('BOverlay', BOverlay);
  app.component('BPagination', BPagination);
  app.component('BPlaceholder', BPlaceholder);
  app.component('BPlaceholderButton', BPlaceholderButton);
  app.component('BPlaceholderCard', BPlaceholderCard);
  app.component('BPlaceholderTable', BPlaceholderTable);
  app.component('BPlaceholderWrapper', BPlaceholderWrapper);
  app.component('BPopover', BPopover);
  app.component('BPopoverOrchestrator', BPopoverOrchestrator);
  app.component('BProgress', BProgress);
  app.component('BProgressBar', BProgressBar);
  app.component('BRow', BRow);
  app.component('BSpinner', BSpinner);
  app.component('BTab', BTab);
  app.component('BTable', BTable);
  app.component('BTableLite', BTableLite);
  app.component('BTableSimple', BTableSimple);
  app.component('BTabs', BTabs);
  app.component('BTbody', BTbody);
  app.component('BTd', BTd);
  app.component('BTfoot', BTfoot);
  app.component('BTh', BTh);
  app.component('BThead', BThead);
  app.component('BToast', BToast);
  app.component('BToastOrchestrator', BToastOrchestrator);
  app.component('BTooltip', BTooltip);
  app.component('BTr', BTr);

  // Directives
  app.directive('b-color-mode', vBColorMode);
  app.directive('b-modal', vBModal);
  app.directive('b-popover', vBPopover);
  app.directive('b-scrollspy', vBScrollspy);
  app.directive('b-toggle', vBToggle);
  app.directive('b-tooltip', vBTooltip);

  // Plugins

  // app.component('BIcon', BIcon);


  app.use(createBootstrap());
}
